import { catchError, map, mergeMap, takeUntil } from "rxjs/operators";
import { ofType } from "redux-observable";
import {
  createReduxObservableModule,
  ReduxObservableModuleEpicProps,
} from "src/core/redux/ReduxObservableModule";
import { of } from "rxjs";
import { Action } from "src/core/models/redux";
import dataLookupRepository from "src/repositories/dataLookup";
import { GetLookup } from "src/models/lookup";

const dataLookupModule = createReduxObservableModule(
  {
    typeLookup: {
      epic: ({
        actions$,
        actionTypes,
        actions,
      }: ReduxObservableModuleEpicProps<Action<GetLookup>>) =>
        actions$.pipe(
          ofType(actionTypes.start),
          mergeMap((action) =>
            dataLookupRepository.listTypeLookup(action.payload).pipe(
              map((response) => actions.success(response.data)),
              catchError((error) => {
                return of(actions.failed(error));
              }),
              takeUntil(actions$.pipe(ofType(actionTypes.cancelled)))
            )
          )
        ),
    },

    customerGroupLookup: {
      epic: ({
        actions$,
        actionTypes,
        actions,
      }: ReduxObservableModuleEpicProps<Action<GetLookup>>) =>
        actions$.pipe(
          ofType(actionTypes.start),
          mergeMap((action) =>
            dataLookupRepository.customerGroupLookup(action.payload).pipe(
              map((response) => actions.success(response.data)),
              catchError((error) => {
                return of(actions.failed(error));
              }),
              takeUntil(actions$.pipe(ofType(actionTypes.cancelled)))
            )
          )
        ),
    },
  },
  "DATALOOKUP"
);

export default dataLookupModule;
